module.exports = __webpack_public_path__ + "static/media/bg-6.6cc34b0c.jpg";